<template>

    <notifications group="notify"/>

</template>
